import React from 'react';
import { Box, Typography } from '@mui/material';

import { AppRetailerBlock, AppValueChip } from '@components';
import { dsColorNew } from '@palette';

/**
 * The rows of the table. On the site axis they get the logo and the flag every other analyzer
 * puts on a web; on the provider axis the brand name travels alone — a brand has no market and
 * no domain of its own.
 */
export default function axisColumn(isSiteAxis) {
	return {
		name: 'name',
		setBodyCellProps: () => ({
			sx: {
				verticalAlign: 'top',
				p: '7px 6px',
				pl: 1.75,
				// pinned, so it takes the row's own stripe instead of letting the fees show through
				backgroundColor: 'inherit',
				borderRight: `1px solid ${dsColorNew.grayBorder}`,
				userSelect: 'none',
				cursor: 'default',
				position: 'sticky',
				top: 0,
				left: 0,
				zIndex: '150 !important',
			},
		}),
		render: (name, row) => <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1, minHeight: 40 }}>
			{isSiteAxis
				? <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
					<AppRetailerBlock retailer={name} icon={row?.nameIcon} country={row?.nameMarket} />
				</Box>
				: <Typography sx={{ textAlign: 'left', fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle }}>
					{name}
				</Typography>}
			{/* the row every other fee is measured against, same "you" tag the other analyzers use */}
			{row?.isMainRow && <AppValueChip tone="accent" sx={{ py: 0.1, px: 0.75, fontSize: 10.5, fontWeight: 700 }}>you</AppValueChip>}
		</Box>
	};
}
